function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/* eslint-disable */
// This icon has been generated. Do not edit it directly.
import React from 'react';
var IconEye = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(IconEye, _React$PureComponent);
  function IconEye() {
    _classCallCheck(this, IconEye);
    return _possibleConstructorReturn(this, _getPrototypeOf(IconEye).apply(this, arguments));
  }
  _createClass(IconEye, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        height = _this$props.height,
        color = _this$props.color,
        onClick = _this$props.onClick,
        size = _this$props.size,
        style = _this$props.style,
        width = _this$props.width,
        className = _this$props.className,
        rest = _objectWithoutProperties(_this$props, ["height", "color", "onClick", "size", "style", "width", "className"]);
      return React.createElement("svg", _extends({}, rest, {
        height: height || size,
        width: width || size,
        onClick: onClick,
        style: style,
        className: className,
        fill: color,
        viewBox: "0 0 512 512"
      }), React.createElement("path", {
        d: "M256.598 401.331c-100.737 0-192.297-69.299-249.788-153.566 58.011-81.315 149.558-137.096 249.788-137.096 100.441 0 192.294 54.81 248.593 136.58-53.382 88.965-144.763 154.082-248.593 154.082M59.555 248.467c48.125 59.44 119.186 110.52 197.044 110.52 106.058 0 174.706-79.477 197.19-110.058-47.83-56.273-118.205-95.916-197.19-95.916-102.597-.001-172.52 67.528-197.044 95.454m199.239-76.379c-46.344 0-83.912 37.568-83.912 83.911 0 46.344 37.569 83.911 83.912 83.911 46.344 0 83.913-37.567 83.913-83.911 0-46.343-37.569-83.911-83.913-83.911m-.077 83.883c-11.845 11.844-31.047 11.844-42.892 0-11.845-11.845-11.845-31.049 0-42.893 11.845-11.845 31.047-11.845 42.892 0 11.846 11.845 11.846 31.049 0 42.893"
      }));
    }
  }]);
  return IconEye;
}(React.PureComponent);
_defineProperty(IconEye, "styleRoot", 'IconEye');
_defineProperty(IconEye, "defaultProps", {
  size: 32,
  color: '#333'
});
export { IconEye as default };